import {Analytics} from '@stripe-internal/conversations-client';
import {useClient} from '@stripe-internal/conversations-ui';

export const useClientAnalytics = (): Analytics => {
  const client = useClient();

  return {
    action: (event, properties) => client.analytics.action(event, properties),
    viewed: (event, properties) => client.analytics.viewed(event, properties),
    track: (event, properties) => client.analytics.track(event, properties),
    requestAnalyticsEventId: () => client.analytics.requestAnalyticsEventId(),
  };
};
